const getClosest = require("../utils/get-closest");

module.exports.start = () => {
  document.addEventListener("DOMContentLoaded", () => {
    const modalActionButtons = [].slice.call(
      document.querySelectorAll(".modal-button-action")
    );

    if (modalActionButtons.length > 0) {
      modalActionButtons.forEach((button) => {
        const [trash] = [].slice.call(
          getClosest(button, ".unified-modal").querySelectorAll(".delete-icon")
        );

        if (trash !== undefined) {
          button.addEventListener("mouseenter", (e) => {
            trash.classList.add("open-trash");
          });

          button.addEventListener("mouseleave", (e) => {
            trash.classList.remove("open-trash");
          });
        }
      });
    }
  });
};
